import { render, staticRenderFns } from "./ConsultationAppointmentTable.vue?vue&type=template&id=a4126d94&"
import script from "./ConsultationAppointmentTable.vue?vue&type=script&lang=js&"
export * from "./ConsultationAppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports